import GiftAnyAmount from "./GiftAnyAmount";

export default GiftAnyAmount;
